"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _core = _interopRequireDefault(require("lodash/core"));

var _legalDocument = _interopRequireDefault(require("./legalDocument"));

var _organization = _interopRequireDefault(require("./organization"));

var _project = _interopRequireDefault(require("./project"));

var _user = _interopRequireDefault(require("./user"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _default() {
  var resolved = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return _core.default.reduce([_legalDocument.default, _organization.default, _project.default, _user.default], function (acc, item) {
    return _objectSpread({}, acc, item(resolved));
  }, {});
}

;